// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateQuestButton_createButton__1IE9E","active__button":"CreateQuestButton_active__button__1P7IS","passive__button":"CreateQuestButton_passive__button__7mGaw"};